"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyIsoCodePattern = exports.countryIsoCodePattern = exports.orgStatuses = exports.otpProviders = void 0;
exports.otpProviders = ['2FACTOR', 'AFRO', 'TWILIO'];
/** New orgs start as DRAFT. Workers can join only when status is ACTIVE. */
exports.orgStatuses = ['DRAFT', 'ACTIVE', 'INACTIVE'];
exports.countryIsoCodePattern = '^[A-Z]{2}$';
exports.currencyIsoCodePattern = '^[A-Z]{3}$';
//# sourceMappingURL=Org.js.map